import { createContext } from 'react';

export interface TranslationsContextProps {
  getPostReviewTranslation: (postDocID: string) => Promise<string | null>;
}

export const TranslationsContext = createContext<TranslationsContextProps>({} as TranslationsContextProps);
